<template>
  <div id="asct" class="section">
    <h1 class="title">{{ $t('it_security_basic_policy.title') }}</h1>
    <hr>
    <div class="margin-top-30px margin-bottom-60px has-text-left">
      <p v-html="$t('it_security_basic_policy.content')"></p>
    </div>
    <p class="has-text-centered" v-html="$t('it_security_basic_policy.footer')"></p>
  </div>
</template>

<script>
import { useSeoHead } from "@/helpers/seo";
import appConfig from "../app.config.json";

export default {
  name: "ITSecurityBasicPolicy",
  created() {
    useSeoHead({
      base: '/it-security-basic-policy',
      locale: this.$i18n.locale,
      title: `${this.$t('it_security_basic_policy.title')} | ${appConfig[this.$i18n.locale].title}`,
      description: String(this.$t('it_security_basic_policy.content')),
    })
  }
}
</script>

<style lang="scss" scoped></style>
